import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "jcboutik_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.sku === product.sku);
      if (ex) {
        return prev.map((i) => (i.sku === product.sku ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [...prev, {
        sku: product.sku, name: product.name, price: product.price,
        image: product.image, quantity: qty,
      }];
    });
    setOpen(true);
  }, []);

  const remove = useCallback((sku) => setItems((p) => p.filter((i) => i.sku !== sku)), []);
  const setQty = useCallback((sku, qty) => {
    setItems((p) => p.map((i) => (i.sku === sku ? { ...i, quantity: Math.max(1, qty) } : i)));
  }, []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
